/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { groupBy } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TherapeuticClassDataGrid } from './TableHead';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const DisplayDrugsTherapeuticClass = (props) => {
  const dispatch = useDispatch();

  const {
    isLoading,
    displayObj: {
      rebateProgramValue,
      fromDateValue,
      rebateProgramList,
      selectedClassValue,
      proccessSearchResult,
      reportSearchResult,
      rebateProgramName,
    },
  } = useSelector((state) => state?.sharedState?.DrugsTherapeuticClassReducer);

  // let rebateProgramNameValue =
  //   rebateProgramList.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${
  //   rebateProgramNameValue?.rebateProgramCd || ''
  // } - ${rebateProgramNameValue?.shortDescr || ''}`;

  // TO get  the complete name of the rebate program
  const rebateProgramNameValue = rebateProgramName;

  const [rows, setRows] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [getProccessTheraClass, setGetProccessTheraClass] =
    React.useState(proccessSearchResult);
  const [getReportTheraClass, setGetReportTheraClass] =
    React.useState(reportSearchResult);
  const [filteredRows, setFilteredRow] = React.useState([]);

  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // To pin the total row
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : getReportTheraClass;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data) : 0.0;
  };

  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        ndc: 'Totals',
        paidAmt: sum('paidAmt').toFixed(2),
        paidUnits: sum('paidUnits').toFixed(4),
        unitPerPackageSize: sum('unitPerPackageSize').toFixed(4),
        packageSize2: sum('packageSize2').toFixed(2),
        origNumOfUnits: sum('origNumOfUnits').toFixed(4),
        unitRebateAmt: sum('unitRebateAmt').toFixed(4),
      });
    }
    return result;
  };

  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [getReportTheraClass, filteredRows]);

  // Set the table data rows for report
  React.useEffect(() => {
    if (proccessSearchResult.length) {
      const groupData = groupBy(proccessSearchResult, 'drugSeqNum');
      const data = reportSearchResult.map((item) => {
        return {
          ...item,
          specTheraClassCd: groupData[item.drugSeqNum][0]?.specTheraClassCd,
        };
      });
      setGetReportTheraClass(data);
    }
  }, [reportSearchResult, proccessSearchResult, filterApply]);

  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  // Below 2 variable for PDF header slected information
  const thirdInfo = rebateProgramNameValue;
  const secondInfo = `Therapeutic Class Codes:${selectedClassValue}`;
  const fourthInfo = `Quarter: ${fromDateValue}`;

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Display Drug Therapeutic Class"
      />

      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Rebate Program: "
                          id="Rebate Program"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebateProgramNameValue}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="Quarter: "
                          id="'Quarter"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={fromDateValue}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div
            className="unallocated bottom-pinned-bold"
            style={{ width: '100vw' }}
          >
            <TableGridWithFeatures
              gridHeight={viewPortHeight_355}
              columnDefs={TherapeuticClassDataGrid}
              rowData={getReportTheraClass.map((item) => {
                return {
                  ...item,
                  paidAmt: item.paidAmt
                    ? parseFloat(item.paidAmt.toFixed(2))
                    : '0.00',
                  unitRebateAmt: item.unitRebateAmt.toFixed(4),
                  unitPerPackageSize: item.unitPerPackageSize.toFixed(4),
                  origNumOfUnits: item.origNumOfUnits.toFixed(4),
                  paidUnits: item.paidUnits.toFixed(4),
                };
              })}
              data-testid="onEditingStopped"
              enterMovesDown
              showResetFilter={false}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              hideTotalCount={false}
              exportFile
              isScrollOn
              reportName="Drug Therapeutic Class Report"
              fileName="Drug Therapeutic Class Report"
              onFilterData={onFilterChanged}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={changeFullScreenView}
              info={{ thirdInfo, secondInfo, fourthInfo }}
              pinnedBottomRowData={pinnedBottomRowData}
              getFilterApply={getFilterApply}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
                NumOfUnitsCellRender: (cellInfo) => {
                  const value = parseFloat(cellInfo?.value);
                  if (cellInfo?.data?.isBottomRow) {
                    const pinnedValue = parseFloat(cellInfo?.value);
                    if (pinnedValue < 0) {
                      return (
                        <b>
                          <span style={{ color: '#eb0000' }}>
                            (
                            {` ${Math.abs(
                              parseFloat(pinnedValue)
                            ).toLocaleString('en-US', {
                              minimumFractionDigits: 4,
                              maximumFractionDigits: 4,
                            })}`}
                            )
                          </span>
                        </b>
                      );
                    }
                    if (pinnedValue) {
                      return (
                        <b>
                          {` ${parseFloat(pinnedValue)?.toLocaleString(
                            'en-US',
                            {
                              minimumFractionDigits: 4,
                              maximumFractionDigits: 4,
                            }
                          )}`}
                        </b>
                      );
                    }
                    return <b> 0.0000</b>;
                  }
                  if (value < 0) {
                    return (
                      <span style={{ color: '#eb0000' }}>
                        (
                        {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                          minimumFractionDigits: 4,
                          maximumFractionDigits: 4,
                        })}
                        )
                      </span>
                    );
                  }
                  if (value) {
                    return ` ${parseFloat(value)?.toLocaleString('en-US', {
                      minimumFractionDigits: 4,
                      maximumFractionDigits: 4,
                    })}`;
                  }
                  return ' 0.0000';
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayDrugsTherapeuticClass;
